:host {
  display: block;
  max-width: 100%;
}

:host([data-is-visible]) {
  display: block;
}

.wrapper {
  padding: 2px;
}

.form-wrapper {
  min-width: 500px;
  max-width: 700px;
  width: 100%;
  height: auto;
}

.form-section {
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gz-form-field {
    &#recurrence-form-field {
      margin-bottom: var(--spacer);
      gz-dropdown {
        margin-left: calc(var(--spacer) * 2);
      }
    }
  }
  .details-container {
    padding: 0 calc(var(--spacer) + 2px) 0 calc(var(--spacer) + 2px);
    border-left: 6px solid var(--blue-layout-200-disabled);
    margin-top: calc(var(--spacer) + 2px);
  }
}

.subsection-title {
  color: var(--chart-300-icon-buttons);
  margin-bottom: calc(var(--spacer) * 3);
  text-transform: uppercase;
}
